// TaskListHeader2.tsx

import "./TaskListHeader2.scss";
import BottomCornerActionIndicator from "../../../../../assets/icons/TaskListHeader2/bottom-corner-action-indicator.svg?react";
import NotiBubbleIcon from "../../../../../assets/icons/TaskListHeader2/noti-bubble-icon.svg?react";

// BADGES
import NewCornerBadgeEn from "../../../../../assets/icons/TaskListHeader2/new-corner-badge_en.svg?react";
import NewCornerBadgeEs from "../../../../../assets/icons/TaskListHeader2/new-corner-badge_es.svg?react";
import NewCornerBadgePtBr from "../../../../../assets/icons/TaskListHeader2/new-corner-badge_ptbr.svg?react";
import NewCornerBadgeId from "../../../../../assets/icons/TaskListHeader2/new-corner-badge_id.svg?react";
import NewCornerBadgeTh from "../../../../../assets/icons/TaskListHeader2/new-corner-badge_th.svg?react";

import { useTranslation } from "react-i18next";
import { useSlice } from "@bridge-applications/provider-kit";
import Skeleton from "../../../../common/Skeleton/Skeleton";

const NEW_CORNER_BADGE_BY_LOCALE: Record<
    string,
    React.FC<React.SVGProps<SVGSVGElement>>
> = {
    en: NewCornerBadgeEn,
    es: NewCornerBadgeEs,
    "pt-br": NewCornerBadgePtBr,
    id: NewCornerBadgeId,
    th: NewCornerBadgeTh,
};

interface ImageConfig {
    scale: number; // e.g. 1.09 = image 9% wider than card
    offsetX: number; // % to shift horizontally (positive = right)
    offsetY: number; // % to shift vertically   (positive = down)
}

const IMAGE_CONFIGS: Record<string, ImageConfig> = {
    "play-and-earn": { scale: 1.09, offsetX: -3.5, offsetY: 7 },
    "a-vs-b": { scale: 1.57, offsetX: 0, offsetY: 0 },
};

const DEFAULT_CONFIG: ImageConfig = { scale: 1, offsetX: 0, offsetY: 0 };

interface TaskListHeader2Props {
    cardItems: {
        id: string;
        imageUrl: string;
        onClick: () => void;
        cornerBadge: "NEW" | "BETA" | undefined;
        notificationCount?: number;
    }[];
}

type LanguageCode = "en" | "es" | "id" | "pt-br" | "th";

export default function TaskListHeader2({ cardItems }: TaskListHeader2Props) {
    const { i18n } = useTranslation();
    const { state: appSlice } = useSlice("appSlice");

    const NewCornerBadge =
        NEW_CORNER_BADGE_BY_LOCALE[i18n.language as LanguageCode] ??
        NewCornerBadgeEn;
    return (
        <div
            className={`task-list-header2 ${appSlice.loading?.appSession ? "is-loading" : ""}`}
        >
            {appSlice.loading?.appSession ? (
                <div className="task-list-header2__skeletons">
                    <Skeleton
                        baseColor="#ffffff"
                        highlightVariation={35}
                        borderRadius={"5vw"}
                        height={"7.32svh"}
                        width={"100%"}
                        opacity={0.25}
                        className="task-list-header2__skeletons__item"
                    />
                    <Skeleton
                        baseColor="#ffffff"
                        highlightVariation={35}
                        borderRadius={"5vw"}
                        height={"7.32svh"}
                        width={"100%"}
                        opacity={0.25}
                        className="task-list-header2__skeletons__item"
                    />
                </div>
            ) : (
                <>
                    {cardItems.map((item) => {
                        const cfg = IMAGE_CONFIGS[item.id] ?? DEFAULT_CONFIG;

                        return (
                            <div
                                key={item.id}
                                className="task-list-header2__card-wrapper"
                            >
                                <button
                                    className="task-list-header2__card"
                                    onClick={item.onClick}
                                >
                                    <img
                                        className="task-list-header2__card__img"
                                        src={item.imageUrl}
                                        alt=""
                                        draggable={false}
                                        style={{
                                            width: `${cfg.scale * 100}%`,
                                            left: `calc(50% + ${cfg.offsetX}%)`,
                                            top: `calc(50% + ${cfg.offsetY}%)`,
                                        }}
                                    />
                                    {item.cornerBadge && (
                                        <div className="task-list-header2__card__badge">
                                            <NewCornerBadge />
                                        </div>
                                    )}

                                    <div className="task-list-header2__card__action-indicator">
                                        <BottomCornerActionIndicator />
                                    </div>
                                </button>

                                {item.notificationCount && (
                                    <div className="task-list-header2__card-wrapper__notification-count">
                                        <p className="task-list-header2__card-wrapper__notification-count__text">
                                            {item.notificationCount}
                                        </p>
                                        <NotiBubbleIcon className="task-list-header2__card-wrapper__notification-count__icon" />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
}
